import { SVGProps } from 'react';

export const MicOn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 21.75C20.49 21.75 22.485 19.74 22.485 17.25L22.5 8.25C22.5 5.76 20.49 3.75 18 3.75C15.51 3.75 13.5 5.76 13.5 8.25V17.25C13.5 19.74 15.51 21.75 18 21.75ZM16.2 8.1C16.2 7.11 17.01 6.3 18 6.3C18.99 6.3 19.8 7.11 19.8 8.1L19.785 17.4C19.785 18.39 18.99 19.2 18 19.2C17.01 19.2 16.2 18.39 16.2 17.4V8.1ZM25.95 17.25C25.95 21.75 22.14 24.9 18 24.9C13.86 24.9 10.05 21.75 10.05 17.25H7.5C7.5 22.365 11.58 26.595 16.5 27.33V32.25H19.5V27.33C24.42 26.61 28.5 22.38 28.5 17.25H25.95Z"
      fill="currentColor"
    />
  </svg>
);

export const MicOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7199 5.39023C10.7199 4.73023 11.2599 4.19023 11.9199 4.19023C12.5799 4.19023 13.1199 4.73023 13.1199 5.39023L13.1099 9.30023L14.9199 11.0902V5.49023C14.9199 3.83023 13.5799 2.49023 11.9199 2.49023C10.3799 2.49023 9.12992 3.65023 8.95992 5.14023L10.7199 6.90023V5.39023ZM18.9199 11.4902H17.2199C17.2199 12.0702 17.1199 12.6202 16.9499 13.1302L18.2199 14.4002C18.6599 13.5202 18.9199 12.5302 18.9199 11.4902ZM4.32992 3.35023L2.91992 4.76023L8.91992 10.7602V11.4902C8.91992 13.1502 10.2599 14.4902 11.9199 14.4902C12.1499 14.4902 12.3599 14.4602 12.5699 14.4102L14.2299 16.0702C13.5199 16.4002 12.7299 16.5902 11.9199 16.5902C9.15992 16.5902 6.61992 14.4902 6.61992 11.4902H4.91992C4.91992 14.9002 7.63992 17.7202 10.9199 18.2102V21.4902H12.9199V18.2102C13.8299 18.0802 14.6899 17.7602 15.4699 17.3102L19.6699 21.5102L21.0799 20.1002L4.32992 3.35023Z"
      fill="#D7373F"
    />
  </svg>
);
